import React from "react";

import {
    Box,
    Button,
    IconButton,
    Modal,
    Stack,
    Typography,
} from "@mui/material";
import Icons from "../helpers/icons";

import { alpha, useTheme } from "@mui/material/styles";

const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    bgcolor: "background.paper",
    borderRadius: "10px",
    boxShadow: 24,
    p: 4,
};

const ModalConfirmation = ({
    answers = [
        {
            title: "Confirm",
            value: "confirm",
            onSelect: () => {},
            severity: 3, // Severity 1 to 3, being 1 "outlined", 3 "contained", and bg color opacity increasing from those two
        },
        {
            title: "Cancel",
            value: "cancel",
            onSelect: () => {},
            severity: 0,
        },
    ],
    setAnswer,
    open,
    setOpen,
    title = "",
    description = "",
    subtitle = "",
    closeButton = true,
}) => {
    const theme = useTheme();

    const handleClose = (answer) => {
        if (answer && answer.value) setAnswer(answer.value);
        answer.onSelect?.();
        setOpen(false);
    };

    return (
        <Modal open={open} onClose={handleClose} aria-labelledby="modal-dialog">
            <Box sx={style}>
                <Stack direction="column" spacing={2}>
                    <Stack
                        direction="row"
                        justifyContent={"space-between"}
                        alignItems={"center"}
                    >
                        {title && (
                            <Typography variant={"h5"} fontWeight={"bold"}>
                                {title}
                            </Typography>
                        )}
                        {closeButton && (
                            <IconButton onClick={handleClose}>
                                <Icons.CloseNavbar />
                            </IconButton>
                        )}
                    </Stack>

                    {subtitle && (
                        <Typography
                            fontStyle={"italic"}
                            style={{
                                wordBreak: "break-word",
                                whiteSpace: "pre-wrap",
                            }}
                        >
                            {subtitle}
                        </Typography>
                    )}

                    {description && (
                        <Typography
                            style={{
                                wordBreak: "break-word",
                                whiteSpace: "pre-wrap",
                            }}
                        >
                            {description}
                        </Typography>
                    )}

                    <Stack
                        direction={answers.length > 2 ? "column" : "row"}
                        justifyContent={"space-around"}
                        display={"flex"}
                        spacing={1}
                    >
                        {answers.map((answer, index) => {
                            const top = answer.hasOwnProperty("severity")
                                ? 3
                                : answers.length - 1;
                            const severity = answer.severity ?? index;
                            const variant =
                                severity === 0 ? "outlined" : "contained";
                            const sx = {
                                textTransform: "none",
                                width: "fit-content",
                                alignSelf: "center",
                            };
                            if (variant === "contained")
                                sx.backgroundColor = alpha(
                                    theme.palette.primary.main,
                                    severity / top
                                );

                            return (
                                <Button
                                    key={answer.title}
                                    onClick={() => handleClose(answer)}
                                    variant={variant}
                                    sx={sx}
                                >
                                    {answer.title}
                                </Button>
                            );
                        })}
                    </Stack>
                </Stack>
            </Box>
        </Modal>
    );
};

export default ModalConfirmation;
